import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authApiSlice } from './authApiSlice';
interface User{
  email:string,
  name:string
  id:number
}
interface InititalState{
  user:null | User
}
const initialState:InititalState={
  user:null
  
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    // builder.addMatcher(defineApiSlice.endpoints.updateProjectTarget.matchFulfilled, (state, action) => {
    //   console.log(action.payload)
    //   state.target = action.payload.target
    // });
    builder.addMatcher(authApiSlice.endpoints.getUserDetails.matchFulfilled, (state, action) => {
      console.log(action.payload)
      state.user=action.payload.user
    });
  }
});

export const {} = authSlice.actions;

export default authSlice.reducer;
